import { forwardRef } from 'react';
import { Flex } from 'antd';
import UtilString from '../../utils/utilString';

const MyFlex = forwardRef(
  (
    {
      block,
      children,
      gap = 10,
      align = 'center',
      className = UtilString.EMPTY_STRING,
      minHeight = UtilString.EMPTY_STRING,
      style,
      ...otherProps
    },
    ref
  ) => {
    return (
      <Flex
        {...otherProps}
        ref={ref}
        gap={gap}
        align={align}
        style={{
          ...style,
          minHeight: minHeight,
        }}
        className={`${block ? 'full_width' : ''} ${className}`}
      >
        {children}
      </Flex>
    );
  }
);

MyFlex.displayName = 'MyFlex';

export default MyFlex;
